import { INT_MODEL } from '../constant/actionTypes';

const getIntelligentModel = (state, action) => {
  switch (action.type) {
    case INT_MODEL.GET.INITIATE:
      return { isFetching: true, data: action.payload };
    case INT_MODEL.GET.SUCCESS:
      return { isFetching: false, data: action.payload };
    case INT_MODEL.GET.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getIntelligentModel;
